import { heroStats } from "@/mocks/howTo";

export default function Hero() {
  return (
    <section id="top" className="w-full border-b border-background-200/70">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-14 lg:py-20">
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 text-xs text-secondary-900">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-bookmark-3-line text-sm" />
            </span>
            导航站整理 · 每天回看一次
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-[42px] md:leading-[1.2]">
            黑料入口
            <span className="mx-1 text-primary-500">·</span>
            推荐 合集 大全 汇总
            <br className="hidden md:block" />
            一次归好，点开就能挑
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-700 md:text-base">
            这是一个偏工具感的黑料入口导航站：把热门黑料与吃瓜站点按题材归好，标清更新时间与入口数量，
            推荐、合集、大全、汇总四类整理方式各自成区。你不用在多个站之间来回跳，点开就能按需挑着看。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#entries"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-door-open-line text-base" />
              </span>
              开始挑入口
            </a>
            <a
              href="#collections"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-900 transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-stack-line text-base" />
              </span>
              查看合集大全
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-3 gap-3 border-t border-background-200/70 pt-6">
            {heroStats.map((stat) => (
              <div key={stat.id}>
                <dt className="text-xs text-foreground-500">{stat.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">{stat.value}</dd>
                <dd className="mt-0.5 text-[11px] text-accent-700">{stat.sub}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="fade-up-delay-1 relative">
          <div className="relative h-[320px] w-full overflow-hidden rounded-lg border border-background-200 bg-background-100 md:h-[440px] lg:h-[520px]">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20torn%20paper%20layers%20and%20geometric%20cards%20on%20warm%20cream%20paper%20background%2C%20terracotta%20orange%20and%20deep%20teal%20accents%2C%20stylized%20flat%20artistic%20poster%20illustration%2C%20soft%20diffused%20light%2C%20clean%20modern%20minimal%20composition%2C%20high%20detail%2C%20harmonious%20warm%20palette&width=1000&height=1200&seq=hlrk-hero-01&orientation=portrait"
              alt="黑料入口导航站首页配图：暖色拼贴风格的入口卡片与分类示意"
              title="黑料入口导航站 入口整理示意"
              className="h-full w-full object-top"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/70 to-transparent p-4 md:p-5">
              <p className="text-xs text-background-100">今日已整理</p>
              <p className="mt-0.5 font-heading text-lg font-bold text-background-50">58 条入口 · 12 个分类</p>
            </div>
          </div>

          <div className="absolute -left-2 top-5 hidden rounded-md border border-background-200 bg-background-50 px-3 py-2 md:block">
            <p className="text-[11px] text-foreground-500">按类归好</p>
            <p className="font-heading text-sm font-bold text-foreground-950">36 个题材分区</p>
          </div>
          <div className="absolute -right-2 bottom-8 hidden rounded-md border border-accent-200 bg-accent-50 px-3 py-2 md:block">
            <p className="text-[11px] text-accent-700">入口醒目</p>
            <p className="font-heading text-sm font-bold text-accent-900">点开即进入</p>
          </div>
        </div>
      </div>
    </section>
  );
}